import React, { useRef } from 'react';
import { Button, Space, message } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import SearchTable from '../../components/admin/SearchTable';
import StatusTag from '../../components/admin/StatusTag';
import { useConfirmModal } from '../../components/ConfirmModal';
import ENDPOINTS from '../../constants/endpoints';
import { ROUTES, formatPath } from '../../constants/PathRoutes';
import api from '../../services/api';
import dayjs from 'dayjs';

export default function AdminBlogList() {
    const navigate = useNavigate();
    const tableRef = useRef();
    const { showConfirm, ConfirmModal } = useConfirmModal();

    const handleDelete = async (id) => {
        showConfirm({
            title: 'Excluir Notícia',
            description: 'Tem certeza que deseja excluir esta notícia?',
            type: 'danger',
            confirmText: 'Excluir',
            cancelText: 'Cancelar',
            onConfirm: async () => {
                try {
                    await api.delete(formatPath(ENDPOINTS.NEWS_DETAIL, { id }));
                    message.success('Notícia excluída com sucesso');
                    tableRef.current?.refetch();
                } catch (error) {
                    message.error('Erro ao excluir notícia');
                }
            }
        });
    };

    const columns = [

        {
            title: 'Título',
            dataIndex: 'title',
            key: 'title',
            ellipsis: true,
        },
        {
            title: 'Autor',
            dataIndex: 'author_fullname',
            key: 'author_fullname',
            width: 150,
            ellipsis: true,
        },

        {
            title: 'Status',
            dataIndex: 'is_active',
            key: 'is_active',
            width: 80,
            render: (isActive) => <StatusTag isActive={isActive} />,
        },
        {
            title: 'Data',
            dataIndex: 'created_at',
            key: 'created_at',
            width: 120,
            render: (date) => dayjs(date).format('DD/MM/YYYY'),
        },
        {
            title: 'Ações',
            key: 'actions',
            width: 100,
            render: (_, record) => (
                <Space>
                    <Button
                        type="primary"
                        icon={<EditOutlined />}
                        size="small"
                        onClick={() => navigate(formatPath(ROUTES.ADMIN_BLOG_EDIT, { id: record.id }))}
                    />
                    <Button
                        danger
                        icon={<DeleteOutlined />}
                        size="small"
                        onClick={() => handleDelete(record.id)}
                    />
                </Space>
            ),
        },
    ];

    return (
        <>
            <SearchTable
                ref={tableRef}
                url={ENDPOINTS.NEWS_LIST}
                columns={columns}
                title="Gerenciamento de Blog"
                buttonProps={{
                    onClick: () => navigate(ROUTES.ADMIN_BLOG_CREATE),
                    label: 'Nova Notícia',
                }}
            />
            <ConfirmModal />
        </>
    );
}
